import React from 'react';

/**
 * History tab — list of past inventory sessions with filters.
 */
const InventoryHistory = ({
  inventorySessions,
  dateFilter, setDateFilter,
  statusFilter, setStatusFilter,
  onRefresh, onOpenSession, onViewSession
}) => (
  <div className="card" style={{ fontSize: '12px' }}>
    <div className="card-header" style={{ padding: '0.4rem 0.75rem' }}>
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0" style={{ fontSize: '13px', fontWeight: '600' }}>Historia inwentaryzacji</h5>
        <div className="d-flex gap-2">
          <input
            type="date"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
            style={{ width: '130px', fontSize: '12px', padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
          />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{ width: '110px', fontSize: '12px', padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
          >
            <option value="">Wszystkie</option>
            <option value="active">Aktywne</option>
            <option value="completed">Zakonczone</option>
          </select>
          <button
            style={{ padding: '6px 12px', fontSize: '12px', backgroundColor: 'var(--card-bg)', color: 'var(--info)', border: '1px solid var(--info)' }}
            onClick={onRefresh}
          >
            <i className="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>
    </div>
    <div className="card-body" style={{ padding: '0.5rem 0.75rem' }}>
      {inventorySessions.length === 0 ? (
        <div className="text-center py-4">
          <div className="text-muted">
            <i className="fas fa-history fa-2x mb-2"></i>
            <p style={{ fontSize: '11px' }}>Brak sesji inwentaryzacji</p>
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table style={{ width: '100%', fontSize: '11px', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Data rozpoczecia', 'Data zakończenia', 'Status', 'Nr dokumentu', 'Produktow', 'Akcje'].map(h => (
                  <th key={h} style={{ padding: '0.3rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontWeight: '600', color: 'var(--text-secondary)' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {inventorySessions.map((session) => (
                <tr key={session.id} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '0.3rem 0.5rem' }}>
                    {new Date(session.start_date).toLocaleDateString('pl-PL')}
                    <br /><small style={{ color: 'var(--text-muted)', fontSize: '10px' }}>{new Date(session.start_date).toLocaleTimeString('pl-PL')}</small>
                  </td>
                  <td style={{ padding: '0.3rem 0.5rem' }}>
                    {session.end_date ? (
                      <>
                        {new Date(session.end_date).toLocaleDateString('pl-PL')}
                        <br /><small style={{ color: 'var(--text-muted)', fontSize: '10px' }}>{new Date(session.end_date).toLocaleTimeString('pl-PL')}</small>
                      </>
                    ) : (
                      <span style={{ color: 'var(--text-muted)' }}>W toku</span>
                    )}
                  </td>
                  <td style={{ padding: '0.3rem 0.5rem' }}>
                    <span style={{
                      fontSize: '10px', padding: '2px 6px', color: '#fff' , borderRadius: '3px',
                      backgroundColor: session.status === 'completed' ? 'var(--success)'
                        : session.status === 'cancelled' ? 'var(--danger)' : 'var(--warning)'
                    }}>
                      {session.status === 'completed' ? 'Zakonczona' : session.status === 'cancelled' ? 'Anulowana' : 'Aktywna'}
                    </span>
                  </td>
                  <td style={{ padding: '0.3rem 0.5rem' }}>
                    <code style={{ fontSize: '10px' }}>{session.document_number || '-'}</code>
                  </td>
                  <td style={{ padding: '0.3rem 0.5rem' }}>
                    <span style={{ fontSize: '10px', padding: '2px 6px', backgroundColor: 'var(--cyan)', color: '#fff' , borderRadius: '3px' }}>
                      {session.total_products || 0}
                    </span>
                  </td>
                  <td style={{ padding: '0.3rem 0.5rem', display: 'flex', gap: '4px' }}>
                    <button
                      style={{ padding: '4px 10px', fontSize: '11px', border: '1px solid var(--info)', color: 'var(--info)', cursor: 'pointer' }}
                      onClick={() => onViewSession ? onViewSession(session) : onOpenSession(session)}
                    >
                      <i className="fas fa-eye me-1"></i>Podglad
                    </button>
                    {session.status === 'active' && (
                      <button
                        style={{ padding: '4px 10px', fontSize: '11px', border: '1px solid var(--success)', color: 'var(--success)', cursor: 'pointer' }}
                        onClick={() => onOpenSession(session)}
                      >
                        <i className="fas fa-edit me-1"></i>Edytuj
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
);

export default InventoryHistory;
